import React from "react";
import { useLocation } from "react-router-dom";
import { useHotel } from "../contexts/HotelContext";
import AuthenticatedLayout from "./AuthenticatedLayout";
import PublicLayout from "./PublicLayout";

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
  showBackButton?: boolean;
}

const Layout: React.FC<LayoutProps> = ({
  children,
  title,
  showBackButton = false,
}) => {
  const { user, isLoading } = useHotel();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen bg-neutral-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto mb-4"></div>
          <p className="text-neutral-600">Loading...</p>
        </div>
      </div>
    );
  }

  // Determine if this is a public page
  const publicPaths = [
    "/offers/public/",
    "/login",
    "/login-success",
    "/status",
  ];

  const isPublicPage = publicPaths.some(
    (path) => location.pathname === path || location.pathname.startsWith(path)
  );

  if (isPublicPage) {
    return <PublicLayout>{children}</PublicLayout>;
  }

  return (
    <AuthenticatedLayout user={user} showBackButton={showBackButton}>
      {children}
    </AuthenticatedLayout>
  );
};

export default Layout;
